const BIND_SUBCATEGORIES = "BIND_SUBCATEGORIES";
const BIND_SUBCATEGORIES_SUCCESS = "BIND_SUBCATEGORIES_SUCCESS";
const BIND_SUBCATEGORIES_FAILURE = "BIND_SUBCATEGORIES_FAILURE";
const CLEAR_BIND_SUBCATEGORIES = "CLEAR_BIND_SUBCATEGORIES";

const bindSubcategoriesSymbols = {
  BIND_SUBCATEGORIES_SUCCESS,
  BIND_SUBCATEGORIES_FAILURE,
  BIND_SUBCATEGORIES,
  CLEAR_BIND_SUBCATEGORIES,
};
export default bindSubcategoriesSymbols;
